import { render } from "./benachrichtigungen.vue?vue&type=template&id=fb2372ca&scoped=true"
import script from "./benachrichtigungen.vue?vue&type=script&lang=js"
export * from "./benachrichtigungen.vue?vue&type=script&lang=js"

import "./benachrichtigungen.vue?vue&type=style&index=0&id=fb2372ca&scoped=true&lang=css"

import exportComponent from "/Users/tommygrimm/IdeaProjects/eurogate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb2372ca"]])

export default __exports__